export default __webpack_public_path__ + "static/matilda-bf1de61bc96c915e2e03a18681616a77.webp";